import { useState, useEffect } from "react";
import { ref, query, get, orderByChild, equalTo } from "firebase/database";
import signatureData from "../../../Signature/Type/SignatureData";
import { SignaturePreview } from "../../../Signature/SignaturePreview";
import { database } from "../../../../firebase";

export default function AdminEmailSignature() {
  const queryParams = new URLSearchParams(window.location.search);
  const user = queryParams.get("userId");
  const [signatureState, setSignatureState] = useState(signatureData);

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;

      try {
        const profilesRef = ref(database, `profiles`);
        const userQuery = query(
          profilesRef,
          orderByChild("userId"),
          equalTo(user)
        );
        const userSnapshot = await get(userQuery);

        if (userSnapshot.exists()) {
          const userData = Object.values(userSnapshot.val())[0]; // Get first matched object
          const usersRef = ref(database, "users/" + user);
          const userssnapshot = await get(usersRef);
          if (userssnapshot.exists()) {
            const Data = userssnapshot.val();
            const companyRef = ref(database, "companies/" + Data.companyId);
            const companysnapshot = await get(companyRef);
            const companiesData = companysnapshot.val();
            console.log(companiesData);
            // Map userData to signatureState
            setSignatureState((prevState) => ({
              ...prevState,
              general: {
                ...prevState.general,
                photo: userData.profilePicture || prevState.general.photo,
                name: `${userData.firstName} ${userData.middleName} ${userData.lastName}`.trim(),
                designation: userData.jobTitle || prevState.general.designation,
                company: userData.companyName || prevState.general.company,
                officeAddress:
                  companiesData.address || prevState.general.officeAddress,
                branch: companiesData.branch || prevState.general.branch,
                awards: userData?.awards || prevState.general.awards,
              },
              contacts: {
                ...prevState.contacts,
                telephone:
                  companiesData.contactNumber || prevState.contacts.telephone,
                phone: userData.contactPhone || prevState.contacts.phone,
                email: userData.contactEmail || prevState.contacts.email,
                website: userData.website || prevState.contacts.website,
                address: userData.address || prevState.contacts.address,
                location: userData.location || prevState.contacts.location,
              },
              social: {
                ...prevState.social,
                facebook:
                  userData.socialLinks?.facebook || prevState.social.facebook,
                linkedin:
                  userData.socialLinks?.linkedin || prevState.social.linkedin,
                github: userData.socialLinks?.github || prevState.social.github,
                twitter:
                  userData.socialLinks?.twitter || prevState.social.twitter,
                instagram:
                  userData.socialLinks?.instagram || prevState.social.instagram,
                youtube:
                  userData.socialLinks?.youtube || prevState.social.youtube,
              },
              emailSignature: {
                ...prevState.emailSignature,
                banner:
                  companiesData.emailSignature?.banner ||
                  prevState.emailSignature.banner,
                awards:
                  companiesData.emailSignature?.awards ||
                  prevState.emailSignature.awards,
                reviewText:
                  companiesData.emailSignature?.reviewText ||
                  prevState.emailSignature.reviewText,
              },
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [user, user.uid]); // Depend on user UID changes

  return (
    <div>
      <div className="min-w-full mx-auto grid gap-8 md:grid-cols-5 items-center">
        {/* Signature Preview (60%) */}
        <div className="md:col-span-3 w-full border-2 rounded-lg">
          <SignaturePreview data={signatureState} />
        </div>
      </div>
    </div>
  );
}
